var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgText14(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 50,
    viewBox: "0 0 48 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 3005"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3071"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.9,
    d: "M40.8516 0.15625V10.7109H47.3594V17.1094H40.8516V27.3906H32.8672V0.15625H40.8516ZM26.8516 2.78125C26.8516 16.2891 18.8125 24.6562 3.33594 28.0469L0.546875 21.7031C12.0039 19.3789 17.1992 14.4844 18.1016 8.90625H3.22656V2.78125H26.8516ZM15.4766 29.25V33.625H32.9766V29.25H40.8516V49.8125H7.54688V29.25H15.4766ZM15.4766 43.4688H32.9766V39.6953H15.4766V43.4688Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText14);
export default __webpack_public_path__ + "static/media/text14.00a0325cd14995e9b69b767ad371d1c5.svg";
export { ForwardRef as ReactComponent };